import { render } from "./AppSaveProjectModal.vue?vue&type=template&id=878f6664&scoped=true"
import script from "./AppSaveProjectModal.vue?vue&type=script&lang=js"
export * from "./AppSaveProjectModal.vue?vue&type=script&lang=js"

import "./AppSaveProjectModal.vue?vue&type=style&index=0&id=878f6664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878f6664"]])

export default __exports__